import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import _ from 'lodash'

import countryList from 'modules/core/lib/countryList'
import i18n from 'modules/core/lib/i18n'

import IncidenceDetailDataChangeLine from 'modules/bookkeepers/components/IncidenceDetailDataChangeLine'
import {
  employeeDataUpdatesTranslation,
  employeeTaxResidenceValueTranslation,
} from 'modules/bookkeepers/lib/dynamicTranslations'
import type IncidenceChanges from 'modules/bookkeepers/store/collections/changes'
import { EMPLOYEE_TRACKED_CHANGES } from 'modules/bookkeepers/store/models/Incidence'
import type IncidenceDetail from 'modules/bookkeepers/store/models/IncidenceDetail'
import { INCIDENCE_TYPES } from 'modules/payroll_bundle/lib/Incidences/Types'

interface Update {
  field: string
  oldValue: string
  newValue: string
}

interface OptionType {
  value: string
  label: string
}

interface CountryList {
  [key: string]: OptionType[]
}

const COUNTRY = 'country'
const IS_RESIDENT = 'is_resident'
const NATIONALITY = 'nationality'

const getUpdates = (newDetail: any, oldDetail: any, incidenceType: string) => {
  const updates: Update[] = []

  _.mergeWith(newDetail, oldDetail, function (objectValue, sourceValue, key) {
    const isCountryIncidencesType =
      incidenceType === INCIDENCE_TYPES.address || incidenceType === INCIDENCE_TYPES.nationality

    const isCountryFieldsType = key === COUNTRY || key === NATIONALITY
    const isResidenceFieldType = key === IS_RESIDENT

    if (!_.isEqual(objectValue, sourceValue) && Object(objectValue) !== objectValue) {
      if (EMPLOYEE_TRACKED_CHANGES[incidenceType]?.includes(key)) {
        if (incidenceType === INCIDENCE_TYPES.irpf) {
          sourceValue = _.isNull(sourceValue) ? sourceValue : parseInt(sourceValue, 10) / 100
          objectValue = _.isNull(objectValue) ? objectValue : parseInt(objectValue, 10) / 100
        }

        if (isCountryIncidencesType && isCountryFieldsType) {
          const countries =
            (countryList as CountryList)[i18n.locale as keyof typeof countryList] || countryList.en
          sourceValue = _.isNull(sourceValue)
            ? sourceValue
            : countries?.find((country) => country.value === sourceValue)?.label
          objectValue = _.isNull(objectValue)
            ? objectValue
            : countries?.find((country) => country.value === objectValue)?.label
        }

        if (isResidenceFieldType) objectValue = employeeTaxResidenceValueTranslation(objectValue)

        const update = {
          field: key,
          oldValue: sourceValue,
          newValue: objectValue,
        }
        updates.push(update)
      }
    }
  })

  return updates
}

interface DataChangeInfoProps {
  incidenceDetailModel: IncidenceDetail
  incidenceChangesCollection: IncidenceChanges
  incidenceType: string
}

const EmployeeDataChangeInfo = ({
  incidenceDetailModel,
  incidenceChangesCollection,
  incidenceType,
}: DataChangeInfoProps) => {
  const newIncidenceDetail = incidenceDetailModel.toJS()

  const oldIncidenceDetail = _.minBy(incidenceChangesCollection.toJS(), 'id')
  const updates = getUpdates(newIncidenceDetail, oldIncidenceDetail, incidenceType)

  const nodes = updates.map<React.ReactNode>((update: Update, index: number) => (
    <IncidenceDetailDataChangeLine
      key={index}
      label={employeeDataUpdatesTranslation(update.field)}
      oldValue={update.oldValue}
      newValue={update.newValue}
    />
  ))

  return <Box gap="s16">{nodes}</Box>
}

export default EmployeeDataChangeInfo
